import React, { memo } from 'react'
import { Container, Titulo, Line1, Line2 } from './bannernoticiasstyle'



const BannerTeam = () => {
  return (
    <Container>
      <Titulo>
        <Line1>Noticias</Line1>
        <Line2>
        Aquí encontrarás las últimas inscripciones a nuestros próximos eventos, así como las noticias más importantes.        </Line2>
      </Titulo>
    </Container>
  )
}

export default memo(BannerTeam)
